<template>
  <div class="container">
    <div class="menu">
      <div class="left">
        <title2 title="精品推荐"></title2>
        <div class="tag-list">
          <div class="tag-item" v-for="(tag,index) in tagList" :class="{'active':tagIndex == index }" @click="getSwiper(tag.id,index)">{{ tag.label }}</div>
        </div>
        <div class="swiper-container2" v-if="showSwiper">
          <div class="swiper-wrapper">
            <div v-for="item in swiperList" :key="item.id" class="swiper-slide" :style="`background-image:url(${ item.selfCoverPath || item.cover})`" @click="goDetail(item)"></div>
          </div>
          <div class="swiper-button-next btn"></div>
          <div class="swiper-button-prev btn"></div>
        </div>
      </div>
      <div class="good-books">
        <div class="book1-3">
          <div class="book2 hvr-bob" :style="{backgroundImage: 'url('+pdata[1].cover+')'}" @click="goDetail(pdata[1])" v-if="pdata[1]">
            <div class="crown"></div>
            <div class="rank"></div>
            <div class="ellipsis-aRow">{{pdata[1].goodsTitle}}</div>
          </div>
          <div class="book1 hvr-bob" :style="{backgroundImage: 'url('+pdata[0].cover+')'}" @click="goDetail(pdata[0])" v-if="pdata[0]">
            <div class="crown"></div>
            <div class="rank"></div>
            <div class="ellipsis-aRow">{{pdata[0].goodsTitle}}</div>
          </div>
          <div class="book3 hvr-bob" :style="{backgroundImage: 'url('+pdata[2].cover+')'}" @click="goDetail(pdata[2])" v-if="pdata[2]">
            <div class="crown"></div>
            <div class="rank"></div>
            <div class="ellipsis-aRow">{{pdata[2].goodsTitle}}</div>
          </div>
        </div>
        <div class="book4 hvr-forward" v-if="pdata[3]" @click="goDetail(pdata[3])">
          <div class="crown">4</div>
          <div class="title ellipsis-aRow">{{pdata[3].goodsTitle}}</div>
        </div>
        <div class="book4 hvr-forward" v-if="pdata[4]" @click="goDetail(pdata[4])">
          <div class="crown">5</div>
          <div class="title ellipsis-aRow">{{pdata[4].goodsTitle}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import title2 from './indexTitle2'
import Swiper from "swiper";
import  { getCatalogList, getResourceList } from "@/api/index/index.js";
export default {
  name: "fine",

  props:['homePageData','homePageData2'],

  data(){
    return{
      tagList: [],
      tagIndex: 0,
      swiperList: [],
      pdata: [],
      showSwiper: true
    }
  },
  components: {title2},
  mounted() {
    getCatalogList({featuredId: this.homePageData.id}).then(res=>{
      this.tagList = res.data
      this.getSwiper(res.data[0].id)
    })
    getResourceList({featuredId: this.homePageData2.id}).then(res=>{
      console.log(res);
      this.pdata = res.data
    })
  },

  methods:{
    getSwiper(id,index){
      this.showSwiper = false
      if(index !== undefined) this.tagIndex = index
      getResourceList({featuredId: this.homePageData.id, catalogId: id}).then(res=>{
        console.log(res,123);
        this.showSwiper = true
        this.swiperList = res.data
        this.$nextTick(()=>{
          this.swiper = new Swiper(".swiper-container2", {
            loop: true, // 无缝
            autoplay: { //自动开始
              delay: 3000, //时间间隔
              disableOnInteraction: false, //*手动操作轮播图后不会暂停*
            },
            paginationClickable: true,
            slidesPerView: 2,
            spaceBetween: 26, // 间隔
            // 如果需要前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          })
        })
      })
    },
    goDetail(item){

      if(item.goodsType == 'train'){
        this.$router.push({
          path: "/willingLearn/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      }else{
        this.$router.push({
          path: "/bookstore/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container{
  /* 弹性布局 默认水平排列 */
  width: 1400px;
  margin: 0 auto;
  /* 溢出隐藏 */
  .menu{
    display: flex;
    justify-content: space-between;
    .left{
      width: 1019px;
      overflow: hidden;
      .tag-list{
        display: flex;
        margin-top: 33px;
        margin-bottom: 30px;
        .tag-item{
          font-size: 24px;
          margin-right: 78px;
          line-height: 1;
          cursor: pointer;
          &.active{
           color: #128bff;
          }
        }
      }
      .swiper-container2{
        position: relative;
      }
      .btn{
        width: 50px;
        height: 130px;
        background-color: #128bff;
        color: #fff;
        top: 100px;
        cursor: pointer;
        opacity: 1;
        &.swiper-button-prev{
          left: 0;
        }
        &.swiper-button-next{
          right: 0;
        }
        &::after{
          font-size: 36px;
          font-weight: 600;
        }
      }
      .swiper-slide {
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        border: 4px solid #fff;
        height: 286px;
        width: 493px;
        background-repeat: no-repeat;
        background-color: #F7F8FA;
        background-size: 100% 100%;
      }
    }
    .good-books{
      width: 360px;
      height: 420px;
      background-image: url('../../../assets/images/goodboos.png');
      background-size: 100% 100%;
      .book1-3{
        display: flex;
        margin-top: 110px;
        justify-content: center;
        margin-bottom: 58px;
        img{
          width: 98px;
          height: 98px;
        }
        & > div{
          cursor: pointer;
          position: relative;
          background-size: 100% 100%;
          .crown{
            width: 50px;
            height: 33px;
            position: absolute;
            top: -23px;
          }
          .rank{
            width: 65px;
            height: 21px;
            position: absolute;
            bottom: -11px;
            overflow: hidden;
            border-radius: 10px;
          }
          .ellipsis-aRow{
            text-align: center;
            margin-top: 99px;
          }
        }
        .book1{
          width: 98px;
          height: 98px;
          margin: 0 32px;
          .crown{
            left: 24px;
            background-image: url('../../../assets/images/crown1.png');
          }
          .rank{
            left: 16px;
            background-image: url('../../../assets/images/ranking1.png');
          }
          .ellipsis-aRow{
            margin-top: 115px;
          }
        }
        .book2{
          width: 85px;
          height: 85px;
          margin-top: 16px;
          .crown{
            left: 16px;
            background-image: url('../../../assets/images/crown2.png');
          }
          .rank{
            left: 8px;
            background-image: url('../../../assets/images/ranking2.png');
          }

        }
        .book3{
          height: 85px;
          width: 85px;
          margin-top: 16px;
          .crown{
            left: 16px;
            background-image: url('../../../assets/images/crown3.png');
          }
          .rank{
            left: 8px;
            background-image: url('../../../assets/images/ranking3.png');
          }
        }
      }
      .book4{
        border-top: 1px solid #eee;
        display: flex;
        height: 73px;
        align-items: center;
        margin: 0 13px;
        cursor: pointer;
        .crown{
          color: #3e75ff;
          line-height: 46px;
          margin-right: 10px;
          font-size: 12px;
          width: 40px;
          height: 40px;
          text-align: center;
          background-image: url("../../../assets/images/crown4.png");
          border-radius: 50%;
        }
        .title{
          font-size: 16px;
          width: 280px;
        }
      }
    }
  }
}

</style>